export default __webpack_public_path__ + "static/media/cabecera-pdf.36deda88.png";